import axios from "axios";
import { useState, useEffect } from "react";
import "../index.css";

const API_BASE = "https://ru.gxpresss.com";

export default function Contact() {
  const initialFormState = {
    clientName: "",
    email: "",
    mobile: "",
    companyName: "",
    businessType: "",
    city: "",
    exportType: "",
    sourcingAddress: "",
    productType:"",
  };

  const [form, setForm] = useState(initialFormState);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const validate = () => {
    let newErrors = {};

    if (!form.clientName?.trim())
      newErrors.clientName = "Client Name is required";
    if (!form.email.includes("@")) newErrors.email = "Enter valid email";
    if (!/^[0-9]{7,15}$/.test(form.mobile))
      newErrors.mobile = "Enter valid mobile number";
    if (!form.sourcingAddress?.trim())
      newErrors.sourcingAddress = "Sourcing address required";
    if (!form.productType?.trim())
      newErrors.productType = "Product type required";
    if (!form.companyName?.trim())
      newErrors.companyName = "Company name is required";
    if (!form.city?.trim()) newErrors.city = "city is required";

    if (!form.exportType) {
      newErrors.exportType = "Please select Export or Import";
    }

    if (!form.businessType?.trim())
      newErrors.businessType = "businessType is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  function FormSelect({ label, error, ...props }) {
    return (
      <div className={`form-group ${error ? "error-state" : ""}`}>
        <label>{label}</label>
        <select {...props}>
          <option value="">Выберите вариант</option>
          <option value="Export">Экспорт</option>
          <option value="Import">Импорт</option>
        </select>
        {error && <span className="field-error">{error}</span>}
      </div>
    );
  }

  useEffect(() => {
    axios.get(`${API_BASE}/api/token`, {
      withCredentials: true,
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");

    if (!validate()) return;

    setLoading(true);

    try {
      await axios.post(`${API_BASE}/api/contact`, form, {
        withCredentials: true,
      });

      setSuccess("Your request has been sent successfully 🚀");

      setForm({
        clientName: "",
        email: "",
        mobile: "",
        companyName: "",
        businessType: "",
        city: "",
        exportType: "",
        sourcingAddress: "",
        productType: "",
      });
    } catch (err) {
      setSuccess("");
      setErrors({ api: "Something went wrong. Please try again." });
    }

    setLoading(false);
  };

  return (
    
    <section id="contact" className="contact-section">
      
      <div className="contact-wrapper">
        <div className="contact-header">
          <h2>Рассчитать стоимость доставки</h2>
          <p>Заполните форму, и мысвяжемсясвами в ближайшее время.</p>
        </div>

        {success && <div className="success-box">{success}</div>}
        {errors.api && <div className="error-box">{errors.api}</div>}

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="grid-2">
            <FormInput
              label="Имя"
              name="clientName"
              value={form.clientName}
              error={errors.clientName}
              onChange={handleChange}
            />
            <FormInput
              label="Мобильный телефон"
              name="mobile"
              type="mobile"
              value={form.mobile}
              error={errors.mobile}
              onChange={handleChange}
            />
            <FormInput
              label="Адрес электронной почты"
              name="email"
              type="email"
              value={form.email}
              error={errors.email}
              onChange={handleChange}
            />
            <FormInput
              label="Название компании "
              name="companyName"
              value={form.companyName}
              error={errors.companyName}
              onChange={handleChange}
            />
            <FormInput
              label="Сфера деятельности"
              name="businessType"
              value={form.businessType}
              error={errors.businessType}
              onChange={handleChange}
            />
            <FormInput
              label="Город"
              name="city"
              value={form.city}
              error={errors.city}
              onChange={handleChange}
            />
            <FormInput
              label="Реализуемая продукция"
              name="productType"
              value={form.productType}
              error={errors.productType}
              onChange={handleChange}
            />

            <FormSelect
              label="Экспорт или импорт"
              name="exportType"
              value={form.exportType}
              error={errors.exportType}
              onChange={handleChange}
            />
          </div>

          <FormInput
            label="Товары поставляются из.../Странапроисхождения товаров"
            name="sourcingAddress"
            value={form.sourcingAddress}
            error={errors.sourcingAddress}
            onChange={handleChange}
          />

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? "Submitting..." : "Узнать стоимость"}
          </button>
        </form>
      </div>
    </section>
  );
}

/* Reusable Components */

function FormInput({ label, error, ...props }) {
  return (
    <div className={`form-group ${error ? "error-state" : ""}`}>
      <label>{label}</label>
      <input {...props} />
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}


